export const removeUnitQuery = `mutation RemoveUnitAllocation($unit: String!, $wingGroupCode: String!) {
  removeUnitAllocation(unit: $unit, wingGroupCode: $wingGroupCode)
}`;

export const saveUnitQuery = `mutation CreateUpdateUnitAllocation($input: UnitAllocationInput!) {
  unitAllocation(input: $input)
}`;

